import { Component, OnInit } from '@angular/core';
import { Message } from 'primeng/components/common/api';
import { FormGroup, FormControl, Validators, FormBuilder, FormArray } from '@angular/forms';
import { MenuItem } from 'primeng/primeng';
import { Router } from '@angular/router';
import { RegistrationService } from '../services/registration.service';
import { MessageService } from 'primeng/components/common/messageservice';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { Interviewcall } from './interviewcall';

@Component({
	selector: 'app-scoreentry',
	templateUrl: './scoreentry.component.html',
	styleUrls: ['./scoreentry.component.scss']
})
export class ScoreentryComponent implements OnInit {
	msgs: Message[] = [];
	user_id: any;
	designationId: any;
	postcategoryid: any;
	departmentId: any;
	processbar: boolean = false;
	public postcategoryList = [];
	public departList = [];
	public postlist = [];
	dataList: any;
	candidateId: any;
	tableData: Interviewcall[];
	researchperFormnaceInfoArray = [];
	researchperFormnaceInfo: any;
	showbtn:boolean=false;
	advid:any;
	departmentFlag: boolean = false;
	did:any;
	constructor(private registrationService: RegistrationService, private router: Router) { }

	ngOnInit() {
		this.user_id = localStorage.getItem('member-id');
		this.designationId = 0;
		this.postcategoryid = 0;
		this.departmentId = 0;
		this.advid=localStorage.getItem('advId');
		this.getAllCommonList();
	}
	getAllCommonList() {
		this.processbar = true;
		this.registrationService.getCommonList(this.advid).then(res => {
			// console.log(res);
			this.dataList = res;
			this.postcategoryList = this.dataList.postcategoryList;
			if(this.advid!=1)
				this.departList = this.dataList.departList;
				// Add by JD
				if (this.dataList.chkdept == 1) 
				this.departmentFlag = true;
				//  end by JD
			this.postlist = this.dataList.postlist;
			this.processbar = false;
		});
	}
	loadCandidateList() {
		this.tableData = [];
		if (this.designationId == 0) {
			this.msgs = [];
			this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Post' });
			return false;
		}
		if (this.postcategoryid == 0) {
			this.msgs = [];
			this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Post Category' });
			return false;
		}
		// if (this.advid != 5) {
		// 	if (this.departmentId == 0) {
		// 		this.msgs = [];
		// 		this.msgs.push({ severity: 'error', summary: 'Error Message', detail: 'Select Department' });
		// 		return false;
		// 	}
		// }
		       // Add by JD
		if(this.departmentFlag == false){ 
            this.did = 0;
			this.departmentFlag = false;
        }else{
            this.did = this.departmentId;
			this.departmentFlag = true;
        }
			//End by JD
		this.processbar = true;
		this.registrationService.loadCandidateList(this.did, this.postcategoryid, this.designationId,this.advid).then(res => {
			// console.log(res, "dept id",this.departmentId);
			this.dataList = res;
			if (this.dataList.msg == "success") {
				this.showbtn=true
				this.tableData = this.dataList.candidateListdtls;
			}
			else {
				alert('Data not found');
				this.tableData = [];
			}
		}).catch(this.handleError);
		this.processbar = false;
	}

	private handleError(error: any): Promise<any> {
		console.error('An error occurred', error);
		alert('An error occurred');
		return Promise.reject(error.message || error);
	}

	saveResearchPerform(){
		this.processbar = true;
		for (let i = 0; i < this.tableData.length; i++) {
			if(this.tableData[i].riderswaivemarks=='-' ||this.tableData[i].riderswaivemarks==''){
				this.tableData[i].riderswaivemarks='0.0';
			}
			if(this.tableData[i].acaelgblgmarks=='-' || this.tableData[i].acaelgblgmarks==''){
				this.tableData[i].acaelgblgmarks='0.0';
			}
			if (this.tableData[i].riderswaivemarks!='' || this.tableData[i].acaelgblgmarks!='') {
				const data = {
					cid: this.tableData[i].id,
					riderswaivemarks:this.tableData[i].riderswaivemarks,
					acaelgblgmarks:this.tableData[i].acaelgblgmarks
				};
				this.researchperFormnaceInfoArray.push(data);
			}
		}
		this.researchperFormnaceInfo = {
			"interviewcallInfo": this.researchperFormnaceInfoArray
		};
		console.log(this.researchperFormnaceInfo);
		this.registrationService.saveResearchPerform(this.researchperFormnaceInfo).then(res => {
			this.dataList = res;
			if (this.dataList.status == 'success') {
				alert("Successfully updated");
			}
			this.researchperFormnaceInfoArray = [];
			this.loadCandidateList();
		}).catch(this.handleError);
		this.processbar = false;
	}

}



// WEBPACK FOOTER //
// ./src/app/scoreentry/scoreentry.component.ts